import logo from './logo.svg';
import ShipExplorer from './components/ShipExplorer';
import './App.css';
import ReactGA from "react-ga4";


function App() {
  // ReactGA.initialize("G-F1Y1QBRFDT");
  // ReactGA.send("pageview");

  return (
    <ShipExplorer />
  );
}

export default App;
